import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import type { HeaderContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const SupplierNameHeader = ({
  column,
  invoiceType,
}: HeaderContext<any, unknown> & { invoiceType?: InvoiceTypeString }) => {
  const { t } = useTranslation();

  return (
    <DataTableColumnHeader
      column={column}
      title={
        invoiceType === undefined
          ? t("suppliers.creditors_slash_debtors")
          : invoiceType === "receivable"
            ? t("debtors.title")
            : t("creditors.title")
      }
    />
  );
};
